<mat-toolbar class="secondary-toolbar mat-elevation-z1">
  <div *ngIf="state!='LIST'" class="secondary-toolbar-item selectable" (click)="showAllEmailTemplates()"><mat-icon>list</mat-icon> All Email Templates</div>
</mat-toolbar>

<section class="main-content">
  <cw-ci-email-template-list #emailTemplateList *ngIf="state=='LIST'" (stateChange)="onStateChange($event)" ></cw-ci-email-template-list>
  <cw-ci-email-template-edit *ngIf="state=='EDIT' || state=='CREATE'" (stateChange)="onStateChange($event)" [emailTemplate]="selectedEmailTemplate"></cw-ci-email-template-edit>
</section>
